import React, { useEffect, useState } from "react";
import useFetch from "../../utils/useFetch";
import useFilters from "../../hooks/useFilters";
import convertToQueryParams from "../../utils/convertToQueryParams";
import Pagination from "../pagination/Pagination";
import { useSearchParams } from 'react-router-dom';

function FAQ() {
  const Api = `system/faqs/`;
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchInput, setSearchInput] = useState(searchParams.get('search') || '');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const initialFilters = {
    ordering: searchParams.get('ordering') || null,
    is_active: true,
    page: parseInt(searchParams.get('page')) || 1,
    size: 10,
    search: searchParams.get('search') || null,
  };

  const {
    filters,
    setFilters,
  } = useFilters(initialFilters);

  const { data, loading, error } = useFetch(`${Api}${convertToQueryParams(filters)}`);


  console.log(`${Api}${convertToQueryParams(filters)}`);
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const updateURL = (newFilters) => {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(newFilters)) {
      if (value) {
        params.set(key, value);
      } else {
        params.delete(key);
      }
    }
    setSearchParams(params);
  };

  const handleSearch = () => {
    const newFilters = { ...filters, search: searchInput.trim() || null, page: 1 };
    setFilters(newFilters);
    updateURL(newFilters);
  };

  const onPageChange = (page) => {
    const newFilters = { ...filters, page };
    setFilters(newFilters);
    updateURL(newFilters);
  };

  return (
    <div className="bg-gray-50">
      <div className="flex justify-center py-10 lg:py-20 bg-page-header-bg bg-brand-100 w-full bg-cover bg-no-repeat bg-bottom bg-page-header">
        <div className="flex mx-auto w-full max-w-screen-2xl px-3 sm:px-10">
          <div className="w-full flex justify-center flex-col relative">
            <h2 className="text-xl md:text-3xl lg:text-4xl font-bold text-center text-black">
              Frequently Asked Questions
            </h2>
          </div>
        </div>
      </div>

      <div className="max-w-screen-2xl mx-auto py-10 px-4 sm:px-10">
        <div className="flex flex-col lg:flex-row gap-8">
          {/* FAQ Section - Takes up 2/3 of the space on larger screens */}
          <div className="w-full lg:w-2/3">
            {/* Search Bar */}
            <div className="mb-6">
              <div className="flex gap-2">
                <input
                  type="text"
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                  placeholder="Search FAQs..."
                  className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-brand-500 focus:border-transparent"
                />
                <button
                  onClick={handleSearch}
                  className="px-6 py-3 bg-brand-600 text-white rounded-lg hover:bg-brand-700 flex items-center justify-center transition-colors"
                  aria-label="Search"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </button>
              </div>
            </div>

            {loading ? (
              // Loading state
              <div className="space-y-4">
                {[...Array(5)].map((_, index) => (
                  <div key={index} className="bg-white p-6 rounded-lg shadow-sm animate-pulse">
                    <div className="h-4 bg-gray-200 rounded w-3/4 mb-4"></div>
                    <div className="h-3 bg-gray-200 rounded w-1/2"></div>
                  </div>
                ))}
              </div>
            ) : error ? (
              // Error state
              <div className="text-center py-10">
                <div className="text-red-500 text-lg">Failed to load FAQs</div>
                <p className="text-gray-600 mt-2">Please try again later</p>
              </div>
            ) : data?.results?.length === 0 ? (
              // No results state
              <div className="text-center py-10">
                <div className="text-gray-500 text-lg">No FAQs found</div>
                <p className="text-gray-600 mt-2">Try adjusting your search terms</p>
              </div>
            ) : (
              // Success state
              <>
                <div className="space-y-4">
                  {data?.results?.map((faq, index) => (
                    <div
                      key={index}
                      className="bg-white rounded-lg shadow-sm transition-all duration-200"
                    >
                      <button
                        className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none"
                        onClick={() => toggleFAQ(index)}
                      >
                        <span className="font-medium text-gray-900">{faq.question}</span>
                        <svg
                          className={`w-5 h-5 text-gray-500 transform transition-transform duration-200 ${
                            openIndex === index ? "rotate-180" : ""
                          }`}
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </button>
                      {openIndex === index && (
                        <div className="px-6 pb-4">
                          <div className="text-gray-600 mt-2">{faq.answer}</div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
                {/* Pagination */}
                <div className="mt-6">
                  <Pagination
                    currentPage={filters.page}
                    totalCount={data?.count || 0}
                    pageSize={filters.size}
                    onPageChange={onPageChange}
                  />
                </div>
              </>
            )}
          </div>

          {/* Contact Information Section - Takes up 1/3 of the space on larger screens */}
          <div className="w-full lg:w-1/3 space-y-6">
            {/* Email Us Box */}
            <div className="border p-10 rounded-lg text-center bg-white">
              <span className="flex justify-center text-4xl text-brand-500 mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                  height="1em"
                  width="1em"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </span>
              <h5 className="text-xl mb-2 font-bold">Email Us</h5>
              <p className="mb-0 text-base opacity-90 leading-7">
                <a href="mailto:info@wholesaledai.com" className="text-brand-600">
                  info@wholesaledai.com
                </a>
                <br />
                We reply within one business day.
              </p>
            </div>

            {/* Call Us Box */}
            <div className="border p-10 rounded-lg text-center bg-white">
              <span className="flex justify-center text-4xl text-brand-500 mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                  height="1em"
                  width="1em"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
              </span>
              <h5 className="text-xl mb-2 font-bold">Call Us</h5>
              <p className="mb-0 text-base opacity-90 leading-7">
                <a href="tel:+9779851448066" className="text-brand-600">
                  +977-9851448066
                </a>
                <br />
                Sunday to Friday, 9am–6pm.
              </p>
            </div>

            {/* Location Box */}
            <div className="border p-10 rounded-lg text-center bg-white">
              <span className="flex justify-center text-4xl text-brand-500 mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth="2"
                  height="1em"
                  width="1em"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
                  />
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                  />
                </svg>
              </span>
              <h5 className="text-xl mb-2 font-bold">Location</h5>
              <p className="mb-0 text-base opacity-90 leading-7">
                <span className="text-brand-600">Address:</span>
                <br />
                O2, Newroad, Kathmandu-22, Nepal
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FAQ;
